import React from 'react';
import { Check, X } from 'lucide-react';
import {
  DEFAULT_PASSWORD_CHECKLIST,
  evaluateDefaultPassword,
} from '../../utils/passwordValidation';

/**
 * Real-time password requirement checklist for default-password fields.
 */
const DefaultPasswordRequirements = ({
  password,
  showWhenEmpty = false,
  itemClassName = 'text-xs',
  helperClassName = 'text-xs text-gray-500',
  className = 'mt-2 space-y-1',
}) => {
  const { checks, categoriesMet, isValid } = evaluateDefaultPassword(password);

  if (!showWhenEmpty && !password) {
    return null;
  }

  return (
    <div className={className}>
      <ul className="space-y-1">
        {DEFAULT_PASSWORD_CHECKLIST.map(({ id, label }) => {
          const met = checks[id];
          const Icon = met ? Check : X;
          return (
            <li
              key={id}
              className={`${itemClassName} flex items-center gap-1.5 ${
                met ? 'text-green-600' : 'text-red-600'
              }`}
            >
              <Icon className="h-3 w-3 shrink-0" aria-hidden="true" />
              <span>{label}</span>
            </li>
          );
        })}
      </ul>
      <p
        className={`${helperClassName} ${
          isValid ? 'text-green-600' : categoriesMet && !checks.minLength ? 'text-red-600' : 'text-gray-500'
        }`}
      >
        {isValid
          ? 'Password meets all requirements.'
          : 'Use at least 8 characters and satisfy at least 3 of the 4 character categories above.'}
      </p>
    </div>
  );
};

export default DefaultPasswordRequirements;
